const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const uploadService = {
  async uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${API_BASE_URL}/upload`, {
        method: 'POST',
        body: formData,
        headers: {
          // No set Content-Type header, let the browser set it with the boundary for multipart/form-data
        },
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Error al subir el archivo');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
};

export default uploadService;
